import type { TransportStats } from '../../clients/HydraClient';
import type { MarketFilterEffective } from '../../workers/feedFilter';

export interface TransportFilterScope {
  socketIncarnation: string;
  sports: string[] | null;
  games: number | null;
  tickers: number | null;
  cadenceMs: number;
  effectiveCadenceMs: number;
}

/** Counts, not thousands of identifiers, on the five-second diagnostic tick. */
export function summarizeTransportScope(scope: MarketFilterEffective, socketIncarnation: string): TransportFilterScope {
  return {
    socketIncarnation, sports: scope.sports ?? null,
    games: scope.games?.length ?? null, tickers: scope.tickers?.length ?? null,
    cadenceMs: scope.cadenceMs, effectiveCadenceMs: scope.effectiveCadenceMs,
  };
}

type RecordedFilter = {
  socketIncarnation: string;
  filterGeneration: number;
  effective: MarketFilterEffective | null;
};

/** Diagnostic recovery for a tab that joined after the worker's filter ack.
 *  Never changes subscriptions, ownership, admission or row freshness. */
export function transportScope(
  recorded: RecordedFilter | undefined,
  stats: TransportStats | null,
  now: number,
): TransportFilterScope | null {
  const scope = stats?.filterScope;
  if (!scope || stats.legacyFallback || stats.filterGeneration == null
    || now - stats.at > 15_000 || now < stats.at) return null;
  // A newer reset can arrive before the next stats tick. Never borrow the
  // previous generation's scope, including an identically numbered socket.
  if (recorded && (recorded.socketIncarnation !== scope.socketIncarnation
    || recorded.filterGeneration !== stats.filterGeneration)) return null;
  return scope;
}
